import { useEffect, useState } from "react";
import { fetchFeaturedNews } from "../services/FeaturedNewsService";
import "../assets/css/news.css";
import { Link } from "react-router-dom";

const FeaturedNews = ({ type, limit }) => {

    const [newsData, setNewsData] = useState([]);

    useEffect(() => {
        fetchFeaturedNews(type,limit)
            .then((response) => {
                console.log(response); // check API response
                setNewsData(response.data); // adjust according to API
            })
            .catch((error) => {
                console.error("Error fetching news:", error);
            });
    }, [type,limit]);

    return (
        <div className="newspaper-container-wrapper featured-newswrapper">
            <div className="container pt-5 pb-0 pb-lg-5 px-0">
                <h3 className="text-lg-center d-none d-lg-block">
                    <marquee>Featured News</marquee>
                </h3>
                <h3 className="text-lg-center d-block d-lg-none">
                    <div>Featured News</div>
                </h3>
                <div className="featured-news-list">
                    {Array.isArray(newsData) && newsData.map((data, index) => (
                        <Link
                            key={data.id}
                            className="featured-news-link"
                            to={`/news/${data.slug}`}
                        >
                            {/* FIRST ITEM */}
                            {index === 0 ? (
                                <div className="featured-first-card featured-card">
                                    <div className="image-wrapper">
                                        <img
                                            src={data.image_url}
                                            className="card-img-top"
                                            alt={data.title}
                                        />
                                    </div>
                                    <div className="card-body mt-3">
                                        <h5>{data.title}</h5>
                                        <small>{data.publish_date}</small>
                                        <div
                                            className="teaser-text"
                                            dangerouslySetInnerHTML={{
                                                __html: data.teaser_text,
                                            }}
                                        ></div>
                                    </div>
                                </div>
                            ) : (
                                /* REMAINING ITEMS */
                                <div className="featured-small-card featured-card">
                                    <h6>{data.title}</h6>
                                    <small>{data.publish_date}</small>
                                    <div
                                        className="teaser-text"
                                        dangerouslySetInnerHTML={{
                                            __html: data.teaser_text,
                                        }}
                                    ></div>
                                </div>
                            )}
                        </Link>
                    ))}
                </div>               
            </div>
        </div>
    );
};

export default FeaturedNews;